import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import ImageUpload from "../../components/common/ImageUpload";
import { createBlogs } from "../../api/blog";

const CreateArticleModal = ({ show, handleClose, onArticleCreated }) => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const payload = { title,featured_image: image, weblink:url,is_active:isActive };

    try {
      const { data } = await createBlogs(payload)
      // Notify parent that a new article has been created.
      onArticleCreated(data.data);
      // Reset the form fields and close the modal.
      setTitle("");
      setImage("");
      setUrl("");
      setIsActive(false)
      handleClose();
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload New Article</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formArticleTitle" className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter article title"
              required
            />
          </Form.Group>



          {image && <div className="border mb-1 hover-shadow d-flex justify-content-center align-items-center"><img style={{width:'100%'}} src={image}  alt=""/></div>}

          <ImageUpload setImage={setImage} />

          <Form.Group controlId="formArticleUrl" className="mb-3">
            <Form.Label>Article URL</Form.Label>
            <Form.Control
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Enter article URL"
              required
            />
          </Form.Group>
          <Form.Group controlId="formLandingCardContent" className="mb-3">
            <div className="d-flex align-items-center">
              <Form.Label className="mb-0 me-2">Status</Form.Label>
              <Form.Switch
                id="custom-switch"
                onChange={(e) => setIsActive(e.target.checked)}
                checked={isActive}
                className="mb-0"
              />
            </div>
          </Form.Group>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Uploading..." : "Upload Article"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateArticleModal;
